export enum AnimationDirection {
  TO_LEFT = 'TO_LEFT',
  TO_RIGHT = 'TO_RIGHT',
  TO_TOP = 'TO_TOP',
  TO_BOTTOM = 'TO_BOTTOM',
}
